/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from 'react-redux';
import { selectChatSessions, selectCurrentProduct, selectHistoryType, selectIsChatSessionsLoading, selectReFetchChatSessions, selectSessionUserId } from '../slice/selectors';
import { selectCurrentSessionId } from '../../../containers/chat/slice/selectors';
import { chatActions } from '../../../containers/chat/slice';
import { portalActions } from '../slice';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SESSION_TYPES } from '../../../containers/chat/slice/constants';
import { ROUTE_PATHS } from '../../../routes/constants';

export const useChatSessionsProvider = () => {
  const chatSessions = useSelector(selectChatSessions);
  const currentSessionId = useSelector(selectCurrentSessionId);
  const dispatch = useDispatch();
  const isChatSessionsLoading = useSelector(selectIsChatSessionsLoading);
  const navigate = useNavigate();
  const historyType = useSelector(selectHistoryType);
  const sessionUserId = useSelector(selectSessionUserId);
  const reFetchChatSessions = useSelector(selectReFetchChatSessions);
  const currentProduct = useSelector(selectCurrentProduct);
  const handleSessionClick = (sessionId: string) => {
    dispatch(chatActions.setCurrentSessionId(sessionId));
    // navigate(`/`);
    navigate(ROUTE_PATHS.PORTAL);
  };

  const getChatSessions = useCallback(() => {
    if (sessionUserId) dispatch(portalActions.getChatSessions({ sessionType: historyType, productId: currentProduct, userId: sessionUserId }));
  }, [historyType, currentProduct, sessionUserId]);

  useEffect(() => {
    getChatSessions();
  }, [getChatSessions, historyType, reFetchChatSessions, currentProduct, sessionUserId]);

  const handleHistoryTypeChange = (type: (typeof SESSION_TYPES)[keyof typeof SESSION_TYPES]) => {
    dispatch(portalActions.changeHistoryType(type));
  };

  return { chatSessions, currentSessionId, handleSessionClick, isChatSessionsLoading, historyType, handleHistoryTypeChange };
};
